import { useState } from 'react';

import config from 'appConfig';
import { Layout, ForgotPasswordForm } from 'lib/auth';
import { Title } from 'components/common';

const pageTitle = `${config.appName} - Forgot Password`;

function ForgotPassword() {
  const [isEmailSent, setIsEmailSent] = useState(false);

  const handleOnSendEmail = (err) => {
    if (!err) setIsEmailSent(true);
  };

  return (
    <Layout
      pageTitle={pageTitle}
      content={
        <div>
          <Title>Forgot Password</Title>
          <p className="mb-2">
            {isEmailSent
              ? 'An email have been sent. Please click the link when you get it. '
              : "Enter your user account's verified email address and we will send you a password reset link."}
          </p>
          {!isEmailSent && (
            <div>
              <ForgotPasswordForm onSendEmail={handleOnSendEmail} />
            </div>
          )}
        </div>
      }
    />
  );
}

ForgotPassword.propTypes = {};

export default ForgotPassword;
